export default __webpack_public_path__ + "static/media/docLogo.c06ab7a1.svg";